const orderApproveData = {
  decisionType: {cancel: '9', pass: '11', refuse: '12', backToSales: '13', backToPrevious: '14', reconsiderPass: '16'},
  mortgageDecisionType: {back: '2', pass: '3'}, // 与enumStore对应
  currentDecisionArray: [],
  form: {
    appCode: null, // 公共审批数据
    type: null, // 审批radio
    passType: null,
    refuseType: null,
    cancelType: null,
    riskCode: null,
    riskName: null,
    backCode: null,
    backType: null,
    backReason: null,
    backReasonBackToPrevious: null,
    remarks: null,
    nextUserId: null,
    nextTrueName: null,
    carResult: null, // 签约审批数据 -- begin
    isCreditReport: null,
    authCh: null,
    pledModelId: null,
    isVipContract: null,
    modelIds: null,
    transferRegDate: null // 签约审批数据 -- end
  },
  formGps: {
    appCode: null,
    carGpsParams: []
  },
  formMortgage: {
    appCode: null,
    cancelReason: null,
    postLoanStatus: null,
    carIdentify: null,
    engineNo: null,
    mortgageDate: null,
    carColor: null,
    transferRegDate: null,
    plateNumber: null,
    loanAfterRemarks: null,
    insured: null
  },
  rules: {
    // 当前审批表单验证规则
    current: {type: [{ required: true, message: '必选', trigger: 'change' }]},
    // 取消审批表单验证规则
    cancel: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      cancelType: [{ required: true, message: '必选', trigger: 'change' }],
      riskCode: [{ required: true, message: '必选', trigger: 'change' }]
    },
    // 通过审批表单验证规则
    pass: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      passType: [{ required: true, message: '必选', trigger: 'change' }],
      riskCode: [{ required: true, message: '必选', trigger: 'change' }]
    },
    // 拒绝审批表单验证规则
    refuse: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      refuseType: [{ required: true, message: '必选', trigger: 'change' }],
      riskCode: [{ required: true, message: '必选', trigger: 'change' }]
    },
    // 退回审批表单验证规则
    backToSales: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      backCode: [{ required: true, message: '必选', trigger: 'change' }],
      backReason: [{ required: true, message: '必填', trigger: 'blur' }]
    },
    // 退回上一步审批表单验证规则
    backToPrevious: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      backReasonBackToPrevious: [{ required: true, message: '必填' }]
    },
    // 签约审批&审批通过时的表单验证规则
    contractPass: {
      type: [{ required: true, message: '必选', trigger: 'change' }],
      carResult: [{ required: true, message: '必选', trigger: 'change' }],
      isCreditReport: [{ required: true, message: '必选', trigger: 'change' }],
      authCh: [{ required: true, message: '必选', trigger: 'change' }],
      pledModelId: [{ required: true, message: '必选', trigger: 'change' }],
      isVipContract: [{ required: true, message: '必选', trigger: 'change' }],
      modelIds: [{ required: true, message: '必选', trigger: 'change' }]
    },
    // 抵押确认 - 附件资料退回
    mortgageBack: {
      postLoanStatus: [{ required: true, message: '必选', trigger: 'change' }],
      cancelReason: [{ required: true, message: '必填', trigger: 'change' }]
    },
    // 抵押确认 - 附件资料通过
    mortgagePass: {
      postLoanStatus: [{ required: true, message: '必选', trigger: 'change' }],
      carIdentify: [{ required: true, message: '必填', trigger: 'change' }],
      engineNo: [{ required: true, message: '必填', trigger: 'change' }],
      mortgageDate: [{ required: true, message: '必填', trigger: 'change' }],
      carColor: [{ required: true, message: '必填', trigger: 'change' }],
      transferRegDate: [{ required: true, message: '必填', trigger: 'change' }],
      plateNumber: [
        { required: true, message: '必填', trigger: 'change' },
        {
          validator: function (rule, value, callback) {
            let result = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/.test(value)
            console.log('in &  result: ' + result)
            if (result) {
              callback()
            } else {
              callback('请输入正确的车牌号')
            }
          }
        }
      ],
      insured: [{ required: true, message: '必填', trigger: 'change' }],
      cancelReason: [{ required: false, message: '必填', trigger: 'change' }]
    }
  }
}

export {
  orderApproveData
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.form.approveData.js